export default "__VITE_ASSET__D9hKiDP$__"